import {FiGithub} from "react-icons/fi";

import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import Button from "@/components/button/Button.tsx";
import {Chip} from "@/components/chip/Chip.tsx";
import {Dot} from "@/components/dot/Dot.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {DeployPrivateLocationButton} from "@/pages/monitoring/privatelocations/list/DeployPrivateLocationButton.tsx";

interface PrivateLocationsControlBarProps {
  privateLocationsAvailable: number;
}

export const PrivateLocationsControlBar = ({privateLocationsAvailable}: PrivateLocationsControlBarProps) => {
  return (
    <ActionBarWrapper
      className={"mb-3"}
      left={
        <div className={"d-flex align-items-center gap-3"}>
          <DeployPrivateLocationButton privateLocationsAvailable={privateLocationsAvailable} />

          <Chip variant={"metric"} size={"smallMedium"}>
            <Dot variant={privateLocationsAvailable > 0 ? "green" : "gray"} size={"legend"} />
            {privateLocationsAvailable} Available
          </Chip>
        </div>
      }
      right={
        <Button
          variant={"secondary"}
          size={"large"}
          as={"a"}
          href={"https://github.com/uptime-com/uptime-private-location"}
          target={"_blank"}
          className={"d-flex align-items-center gap-1 text-nowrap"}
        >
          <Icon icon={FiGithub} /> Github Repo
        </Button>
      }
    />
  );
};
